var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "table-card mar" },
    [
      _c("div", { staticClass: "table-title" }, [
        _vm._v("每日达成"),
        _c("span", [_vm._v("Diário")]),
      ]),
      _c(
        "el-table",
        {
          staticClass: "dashboard-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            fit: "",
            "highlight-current-row": "",
            "max-height": "400",
            "row-key": "_rowKey",
            "default-expand-all": true,
            "tree-props": { children: "children", hasChildren: "hasChildren" },
            "cell-class-name": _vm.cellClassName,
            "row-class-name": _vm.rowClassName,
            "header-row-class-name": _vm.headerRowClassName,
          },
        },
        [
          _vm.tableData.length > 0
            ? _c(
                "el-table-column",
                {
                  attrs: {
                    label: "月 Mês",
                    align: "center",
                    width: "180",
                    fixed: "left",
                    "label-class-name": "fixed-header-label",
                  },
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", { staticClass: "fixed-header-label" }, [
                      _c("span", { staticClass: "fixed-header-label__zh" }, [
                        _vm._v("月"),
                      ]),
                      _c("span", { staticClass: "fixed-header-label__pt" }, [
                        _vm._v("Mês"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "天 Dia",
                        align: "center",
                        width: "180",
                        "label-class-name": "fixed-header-label",
                      },
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", { staticClass: "fixed-header-label" }, [
                          _c(
                            "span",
                            { staticClass: "fixed-header-label__zh" },
                            [_vm._v("天")]
                          ),
                          _c(
                            "span",
                            { staticClass: "fixed-header-label__pt" },
                            [_vm._v("Dia")]
                          ),
                        ]),
                      ]),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "大区 / 州 Região / UF",
                            prop: "region",
                            align: "left",
                            width: "180",
                            "label-class-name": "fixed-header-label",
                          },
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("div", { staticClass: "fixed-header-label" }, [
                              _c(
                                "span",
                                { staticClass: "fixed-header-label__zh" },
                                [_vm._v("大区 / 州")]
                              ),
                              _c(
                                "span",
                                { staticClass: "fixed-header-label__pt" },
                                [_vm._v("Região / UF")]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._l(_vm.columns, function (month) {
            return _c(
              "el-table-column",
              {
                key: month.key,
                attrs: { label: month.label, align: "center" },
              },
              [
                _vm._l(month.days, function (day) {
                  return _c(
                    "el-table-column",
                    {
                      key: day.key,
                      attrs: { label: day.label, align: "center" },
                    },
                    [
                      _vm.showQtd
                        ? _c("el-table-column", {
                            attrs: {
                              label: "QTD",
                              align: "center",
                              "min-width": "90",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row[day.key + "_qtd"])),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label: "%",
                          align: "center",
                          "min-width": "90",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: _vm.rateClass(
                                        row[day.key + "_rate"],
                                        row
                                      ),
                                    },
                                    [_vm._v(_vm._s(row[day.key + "_rateFmt"]))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      label: _vm.totalLabel,
                      align: "center",
                      "label-class-name": "total-header-cell",
                    },
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("div", { staticClass: "total-header-label" }, [
                        _c("span", { staticClass: "total-header-label__zh" }, [
                          _vm._v("总计"),
                        ]),
                        _c("span", { staticClass: "total-header-label__pt" }, [
                          _vm._v("Total Mês"),
                        ]),
                      ]),
                    ]),
                    _vm.showQtd
                      ? _c("el-table-column", {
                          attrs: {
                            label: "QTD",
                            align: "center",
                            "min-width": "90",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          month.total
                                            ? row[
                                                month.total.key + "_total_qtd"
                                              ]
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "%", align: "center", "min-width": "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "span",
                                  {
                                    class: _vm.rateClass(
                                      month.total
                                        ? row[month.total.key + "_total_rate"]
                                        : null,
                                      row
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        month.total
                                          ? row[
                                              month.total.key + "_total_rateFmt"
                                            ]
                                          : "-"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  2
                ),
              ],
              2
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }